import { lazy } from "react";

export const Layouts = {
  sleekLayout: lazy(() => import("./sleek-layout/SleekLayout")),
};